import { useEffect } from "react";

/**
 * Native scroll with anchor-link smoothing.
 * (Lenis removed — it was making the wheel feel sluggish.)
 */
export default function SmoothScroll({ children }) {
    useEffect(() => {
        const onAnchor = (e) => {
            const a = e.target.closest("a[href^='#']");
            if (!a) return;
            const id = a.getAttribute("href");
            if (!id || id === "#") return;
            const el = document.querySelector(id);
            if (el) {
                e.preventDefault();
                const top = el.getBoundingClientRect().top + window.scrollY - 40;
                window.scrollTo({ top, behavior: "smooth" });
            }
        };
        document.addEventListener("click", onAnchor);
        return () => document.removeEventListener("click", onAnchor);
    }, []);

    return <>{children}</>;
}
